const ONBOARDING_STATUSES = {
  invited: 'invited',
  started: 'started',
  completed: 'completed',
};

const ONBOARDING_STEPS = {
  start: '',
  unboxing: 'unboxing',
  storing: 'storing',
  transitioning: 'transitioning',
  serving: 'serving',
  whatToExpect: 'what_to_expect',
  feedingTips: 'feeding_tips',
  success: 'success',
  feedback: 'feedback',
};

// Subtract 2 because we don't count start and feedback as a steps
// Subtract 1 because transitioning page is only shown for pets on transition
const ONBOARDING_NUM_STEPS_SINGLE_PET = Object.keys(ONBOARDING_STEPS).length - 3;
const ONBOARDING_NUM_STEPS_PER_EXTRA_PET = 2;

export {
  ONBOARDING_STATUSES,
  ONBOARDING_STEPS,
  ONBOARDING_NUM_STEPS_SINGLE_PET,
  ONBOARDING_NUM_STEPS_PER_EXTRA_PET,
};
